import { BellRing } from 'lucide-react';
import { useI18nStore } from '../../shared/i18n/i18nStore';
import { SheetPortal } from '../../shared/ui/SheetPortal';

type NotificationToggleKind = 'activity' | 'device';

export function NotificationToggleConfirm({
  kind,
  nextEnabled,
  pending = false,
  onCancel,
  onConfirm,
}: {
  kind: NotificationToggleKind;
  nextEnabled: boolean;
  pending?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  const t = useI18nStore((state) => state.t);
  const prefix = kind === 'activity' ? 'activityNotificationConfirm' : 'deviceNotificationConfirm';
  const action = nextEnabled ? 'Enable' : 'Disable';
  const title = t(`${prefix}${action}Title`);
  const body = t(`${prefix}${action}Body`);

  return (
    <SheetPortal>
      <div className="sheet-backdrop notification-confirm-backdrop" role="presentation" onMouseDown={() => { if (!pending) onCancel(); }}>
        <section
          className="profile-sheet notification-confirm-sheet"
          role="dialog"
          aria-modal="true"
          aria-label={title}
          onMouseDown={(event) => event.stopPropagation()}
          data-notification-confirm={kind}
          data-next-enabled={String(nextEnabled)}
        >
          <div className="sheet-grabber" />
          <span className="notification-confirm-icon" aria-hidden="true"><BellRing size={24} /></span>
          <div className="notification-confirm-copy">
            <h2>{title}</h2>
            <p>{body}</p>
          </div>
          <div className="notification-confirm-actions">
            <button className="notification-confirm-cancel tap" type="button" disabled={pending} onClick={onCancel}>
              {t('notificationConfirmCancel')}
            </button>
            <button className="notification-confirm-submit tap" type="button" disabled={pending} onClick={onConfirm}>
              {pending ? t('submitting') : t(nextEnabled ? 'notificationConfirmEnable' : 'notificationConfirmDisable')}
            </button>
          </div>
        </section>
      </div>
    </SheetPortal>
  );
}
